import store from '@/store'

import {
  dateOperating
} from '@/cllib/tools'

import {
  piChartGetData
} from '@/api/api'

let dcopy = require('deep-copy')

const carStartWorkTime = '08:00:00'
const carEndWorkTime = '23:00:00'
const workTime = {'startHour': 8, 'endHour': 23, 'workHours': 15, 'restHours': 9}
const hourTimestamp = 60 * 60 * 1000
const dayTimestamp = hourTimestamp * 24

window.test = () => {
  return getUseCarTimeRange([{gasId: 1, gasTankId: 1000, volume: 20000, onWayHour: 3, backOnWayHour: 3, carBinNo: '1'}, {gasId: 2, gasTankId: 1223, volume: 20000, onWayHour: 3, carBinNo: '2'}])
}

export async function loadData (idList, matchDay) {
  let parm = {
    'sendDate': matchDay || '2020-04-15',
    'gasTankIds': idList
  }
  let data = await piChartGetData(parm)
  return data
}

export async function getUseCarTimeRange (dataList) {
  dataList = dcopy(dataList)
  if (dataList && dataList.length === 0) {
    return null
  }
  let idList = []
  let maxbeforeHour = 0
  let maxAfterHour = 0
  let tankMap = {}
  let gasIds = []
  dataList.forEach((item) => {
    if (!item.onWayHour) {
      item.onWayHour = (item.distance || 300) / 50
    }
    item.loadHour = item.loadHour || 1
    item.waitHour = item.waitHour || 1
    item.beforeHour = item.onWayHour + item.loadHour + item.waitHour
    item.afterHour = item.backOnWayHour || item.onWayHour
    if (item.beforeHour + item.afterHour > maxAfterHour + maxbeforeHour) {
      maxbeforeHour = item.beforeHour
      maxAfterHour = item.afterHour
    }
    if (!gasIds.includes(item['gasId'])) {
      gasIds.push(item['gasId'])
    }
    if (!idList.includes(item['gasTankId'])) {
      idList.push(item['gasTankId'])
      tankMap[item['gasTankId']] = item
      tankMap[item['gasTankId']].carBinNoList = [item['carBinNo']]
      tankMap[item['gasTankId']].tank = {}
      tankMap[item['gasTankId']].hourStatus = []
    } else {
      tankMap[item['gasTankId']]['volume'] += item['volume']
      tankMap[item['gasTankId']].carBinNoList.push(item['carBinNo'])
    }
  })

  if (gasIds.length > 1) {
    let addHour = (dataList.length - 1) * 0.5
    maxbeforeHour += addHour
    maxAfterHour += addHour
    for (let key in tankMap) {
      tankMap[key]['beforeHour'] += addHour
      tankMap[key]['afterHour'] += addHour
    }
  }
  let data = null
  try {
    data = await loadData(idList, store.getters.adjustDate)
  } catch (error) {
    data = []
  }
  data.forEach((item) => {
    item.gasTankInfo = item.gasTankInfo || {}
    item.gasTankInfo.emptyTime = item.emptyTime
    tankMap[item.gasTankId].tank = item.gasTankInfo
    tankMap[item.gasTankId].hourStatus = item.gasTankStatusVos || []
  })
  let newData = []
  let useCarTimeRange = true
  let start = store.getters.adjustDate + ' ' + carStartWorkTime
  for (let gasTankId in tankMap) {
    let oneUseCarTimeRange = getOneUseCarTimeRange(tankMap[gasTankId])
    tankMap[gasTankId].carBinNoList.forEach((item) => {
      newData.push({
        carBinNo: item,
        gasTankId: gasTankId,
        gasId: tankMap[gasTankId].gasId,
        useCarTimeRange: oneUseCarTimeRange,
        timeLong: tankMap[gasTankId].beforeHour + tankMap[gasTankId].afterHour,
        beforeLong: tankMap[gasTankId].beforeHour
      })
    })
    if (oneUseCarTimeRange) {
      start = maxTime(oneUseCarTimeRange.minStart, start)
    }
    useCarTimeRange = mergeUseTimeRange(useCarTimeRange, oneUseCarTimeRange, maxbeforeHour, maxAfterHour)
  }
  useCarTimeRange = useCarTimeRange === true ? null : useCarTimeRange
  if (!useCarTimeRange) {
    useCarTimeRange = {
      start: start,
      timeLong: maxbeforeHour + maxAfterHour
    }
  } else {
    useCarTimeRange.start = useCarTimeRange['minStart']
    useCarTimeRange.timeLong = maxbeforeHour + maxAfterHour
  }
  return {
    useCarTimeRange: useCarTimeRange,
    detail: newData
  }
}

export const getOneUseCarTimeRange = ({tank, hourStatus, volume, beforeHour, afterHour}) => {
  let maxVolume = tank['validCapacity'] - tank['stopPumpCapacity']
  if (isNaN(maxVolume) || !hourStatus || volume > maxVolume || hourStatus.length === 0) {
    return null
  }
  let i = hourStatus.length - 1
  let carArriveTime = {'maxTime': null, 'minTime': null}
  while (i > -1 && !hourStatus[i]['inVolume']) {
    let currentData = hourStatus[i]
    if (!atWorkTime(currentData['currentTime'], 'gas')) {
      // 夜间断油
      if (tank['stopPumpCapacity'] === currentData['currentInventory'] || tank['stopPumpCapacity'] > currentData['currentInventory']) {
        carArriveTime['maxTime'] = null
        carArriveTime['minTime'] = null
      }
      i -= 1
      continue
    }
    if (volume < currentData['emptyInventory']) {
      carArriveTime['maxTime'] = carArriveTime['maxTime'] || currentData['currentTime']
      carArriveTime['minTime'] = currentData['currentTime']
    } else {
      break
    }
    i -= 1
  }
  if (carArriveTime['maxTime'] === null && carArriveTime['minTime'] === null) {
    return null
  }
  carArriveTime['maxTime'] = maxTime(minTime(carArriveTime['maxTime'], tank['emptyTime']), carArriveTime['minTime'])
  let useCarTimeRange = {
    'minEnd': carArriveTime['minTime'],
    'maxEnd': carArriveTime['maxTime']
  }
  useCarTimeRange['minStart'] = getLoadTime(useCarTimeRange['minEnd'], beforeHour)
  useCarTimeRange['maxStart'] = getLoadTime(useCarTimeRange['maxEnd'], beforeHour)
  useCarTimeRange['maxBak'] = getArrivalTime(useCarTimeRange['maxEnd'], afterHour)
  useCarTimeRange['minBak'] = getArrivalTime(useCarTimeRange['minEnd'], afterHour)
  return useCarTimeRange
}

export const maxTime = (t1, t2) => {
  return t1 > t2 ? t1 : t2
}

export const minTime = (t1, t2) => {
  return t1 < t2 ? t1 : t2
}

export const getLoadTime = (arrivalTime, onWayHour) => {
  let newArrivalTime = null
  if (atWorkTime(arrivalTime, 'car')) {
    newArrivalTime = dateOperating.formatDate({date: dateOperating.formatDate({date: arrivalTime, format: 'yy-mm-dd'}) + ' ' + carEndWorkTime, format: 'stamps'})
    arrivalTime = dateOperating.formatDate({date: arrivalTime, format: 'stamps'})
    onWayHour += (newArrivalTime - arrivalTime) / hourTimestamp
  } else {
    newArrivalTime = dateOperating.formatDate({date: dateOperating.formatDate({date: dateOperating.formatDate({date: arrivalTime, format: 'stamps'}) - workTime.restHours * hourTimestamp, format: 'yy-mm-dd'}) + ' ' + carEndWorkTime, format: 'stamps'})
  }
  newArrivalTime = newArrivalTime - parseInt(onWayHour / workTime['workHours']) * dayTimestamp - (onWayHour % workTime['workHours']) * hourTimestamp
  let loadTime = dateOperating.formatDate({date: newArrivalTime, format: 'yy-mm-dd hh:mm:ss'})
  return loadTime.slice(11, 19) !== carEndWorkTime ? loadTime : dateOperating.formatDate({date: newArrivalTime + workTime['restHours'] * hourTimestamp, format: 'yy-mm-dd hh:mm:ss'})
}

export const atWorkTime = (time1, target) => {
  let result = false
  time1 = dateOperating.formatDate({date: time1, format: 'stamps'})
  let t1 = dateOperating.formatDate({date: time1, format: 'yy-mm-dd'}) + ' ' + carStartWorkTime
  t1 = dateOperating.formatDate({date: t1, format: 'stamps'})
  let t2 = dateOperating.formatDate({date: time1, format: 'yy-mm-dd'}) + ' ' + carEndWorkTime
  t2 = dateOperating.formatDate({date: t2, format: 'stamps'})
  if (target === 'car') {
    result = (time1 > t1 || time1 === t1) && time1 < t2
  } else {
    result = time1 > t1 && (time1 < t2 || time1 === t2)
  }
  return result
}

export const getArrivalTime = (startTime, onWayHour) => {
  let newStartTime = null
  if (atWorkTime(startTime, 'gas')) {
    newStartTime = dateOperating.formatDate({date: dateOperating.formatDate({date: startTime, format: 'yy-mm-dd'}) + ' ' + carStartWorkTime, format: 'stamps'})
    startTime = dateOperating.formatDate({date: startTime, format: 'stamps'})
    onWayHour += (startTime - newStartTime) / hourTimestamp
  } else {
    newStartTime = dateOperating.formatDate({date: dateOperating.formatDate({date: dateOperating.formatDate({date: startTime, format: 'stamps'}) + workTime.restHours * hourTimestamp, format: 'yy-mm-dd'}) + ' ' + carStartWorkTime, format: 'stamps'})
  }
  newStartTime = newStartTime + parseInt(onWayHour / workTime['workHours']) * dayTimestamp + (onWayHour % workTime['workHours']) * hourTimestamp
  let arrivalTime = dateOperating.formatDate({date: newStartTime, format: 'yy-mm-dd hh:mm:ss'})
  return arrivalTime.slice(11, 19) !== carStartWorkTime ? arrivalTime : dateOperating.formatDate({date: newStartTime - workTime['restHours'] * hourTimestamp, format: 'yy-mm-dd hh:mm:ss'})
}

export const mergeUseTimeRange = (useCarTimeRange1, useCarTimeRange2, beforeHour, afterHour) => {
  if (useCarTimeRange1 === true && useCarTimeRange2) {
    return useCarTimeRange2
  } else if (!useCarTimeRange1 || !useCarTimeRange2) {
    return null
  }
  let data = {
    'minStart': maxTime(useCarTimeRange1['minStart'], useCarTimeRange2['minStart']),
    'maxStart': minTime(useCarTimeRange1['maxStart'], useCarTimeRange2['maxStart'])
  }
  if (data['minStart'] > data['maxStart']) {
    return null
  }
  data['minEnd'] = getArrivalTime(data['minStart'], beforeHour)
  data['maxEnd'] = getArrivalTime(data['maxStart'], beforeHour)
  data['minBak'] = getArrivalTime(data['minEnd'], afterHour)
  data['maxBak'] = getArrivalTime(data['maxEnd'], afterHour)
  data['start'] = data['minStart']
  return data
}

export default {
  getArrivalTime,
  getLoadTime
}

window.testFun = {
  getArrivalTime,
  getLoadTime,
  getUseCarTimeRange
}



// WEBPACK FOOTER //
// ./src/cllib/use_car_time.js